export const yearShortFormat = (date: string) => {
  try {
    const extractedYear = date.split("-").filter((block) => block.length === 4)[0];
    return extractedYear ? extractedYear : "Invalid time value";
  } catch (error) {
    return "Invalid time value";
  }
};
